import { makeVar } from '@apollo/client';

/**
 * The mobile signing sheet auto-focuses its input only when the user
 * explicitly opened or advanced it (tapping a field, or pressing Next). It
 * must NOT auto-focus when the walkthrough auto-starts from the
 * `?walkthrough=true` URL param on load: on Android, programmatically focusing
 * an input pops the soft keyboard, so an auto-opened sheet would surface the
 * keyboard before the user has interacted with anything. iOS doesn't pop the
 * keyboard without a user gesture, which is why this only manifests on Android.
 *
 * Lives in its own module so the sheet, its in-sheet footer, and the FAB can
 * all read/write it without an import cycle.
 */
export const mobileSheetAutoFocusVar = makeVar(false);
